import { render, staticRenderFns } from "./AttachmentDropzone.vue?vue&type=template&id=34187e08&scoped=true&"
import script from "./AttachmentDropzone.vue?vue&type=script&lang=js&"
export * from "./AttachmentDropzone.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDropzone.vue?vue&type=style&index=0&id=34187e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34187e08",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton} from 'bootstrap-vue'
    installComponents(component, {BButton})
    

export default component.exports